import CircularProgress from '@material-ui/core/CircularProgress'
//import InputLabel from "@material-ui/core/InputLabel";
import {
  createTheme,
  makeStyles,
  MuiThemeProvider
} from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
// core components
import styles from 'assets/jss/style-component/components/customInputStyle.js'
import classNames from 'classnames'
import { GridItem } from 'components'
import PropTypes from 'prop-types'
import React from 'react'
//import { TIPO_INPUT } from "util/common/const.js";
import ReactTooltip from 'react-tooltip'

const theme = createTheme({
  overrides: {
    MuiInputBase: {
      root: {
        // backgroundColor: "#fff  !important",
        fontSize: 'small  !important'
      }
    },
    MuiAutocomplete: {
      root: {
        //backgroundColor: "#fff  !important",
        fontSize: 'small  !important'
      },
      inputRoot: {
        padding: '0px !important'
      },
      popper: {},
      option: {
        fontSize: 'small  !important',
        backgroundColor: '#fff  !important',
        '&[data-focus="true"]': {
          backgroundColor: '#0681b5 !important'
        }
      }
    },
    PrivateNotchedOutline: {
      legendLabelled: {},
      legendNotched: {
        maxWidth: '0px !important'
      }
    }
  }
})

const useStyles = makeStyles(styles)

export default function CustomSelect(props) {
  const classes = useStyles()
  const {
    id,
    style,
    open,
    onOpen,
    onClose,
    value,
    onChange,
    getOptionSelected,
    getOptionLabel,
    options,
    loading,
    renderOption,
    labelText,
    error,
    success,
    helperText,
    sm,
    md,
    blanco,
    autoFocus,
    disabled,
    variant,
    inputRef
  } = props
  const labelClasses = classNames({
    [' ' + classes.labelRootError]: error,
    [' ' + classes.labelRootSuccess]: success && !error,
    [' ' + classes.labelRootBlanco]: blanco && !success && !error
  })

  return (
    <GridItem xs={12} sm={sm === null ? 12 : sm} md={md}>
      <MuiThemeProvider theme={theme}>
        {labelText !== undefined ? <div> {labelText} </div> : null}
        <Autocomplete
          data-tip={helperText}
          id={id}
          style={style}
          open={open}
          onOpen={onOpen}
          onClose={onClose}
          value={value}
          onChange={onChange}
          getOptionSelected={getOptionSelected}
          getOptionLabel={getOptionLabel}
          options={options}
          loading={loading}
          renderOption={renderOption}
          className={classes.labelRoot + labelClasses}
          disabled={disabled}
          renderInput={params => (
            <TextField
              {...params}
              label=""
              variant={'standard'}
              size="small"
              fullWidth
              autoFocus={autoFocus}
              inputRef={inputRef}
              InputLabelProps={{
                shrink: true
              }}
              error={error}
              className={classes.labelRoot + labelClasses}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                )
              }}
            />
          )}
        />
        <ReactTooltip />
      </MuiThemeProvider>
    </GridItem>
  )
}

CustomSelect.propTypes = {
  formControlProps: PropTypes.object,
  id: PropTypes.string,
  style: PropTypes.object,
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  getOptionSelected: PropTypes.func,
  getOptionLabel: PropTypes.func,
  options: PropTypes.array,
  loading: PropTypes.bool,
  renderOption: PropTypes.func,
  labelText: PropTypes.node,
  error: PropTypes.bool,
  success: PropTypes.bool,
  sm: PropTypes.number,
  md: PropTypes.number,
  value: PropTypes.object,
  onChange: PropTypes.func,
  helperText: PropTypes.string,
  blanco: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  inputRef: PropTypes.any,
}
